<main class="main">
    <div class="Wrapper">
        <section class="section">
            <div class="content content_wide introduction-block">
                <div class="introduction">
                    <div class="introduction__info margin-left-10">

                    <h1><u><b>Enrollment is now CLOSED</b></u> for the Brain Tumor Project (BTproject)</h1>

                    <br><br>
                    <div class="logos margin-left-10">
                        <div class="Intro-arrow">
                            <a (click)="scrollTo(secondView)"><img src="./assets/images/arrow.svg" alt="Arrow"></a>
                        </div>
                    </div>
                    <br><br>

                    <div class="logos margin-left-10">
                        <img class="logos__wide" src="assets/images/logo-broad-institute.png"
                            [alt]="'HomePage.Introduction.BroadAlt'">
                        <img class="logos__wide" src="assets/images/logo-dana-farber-cancer-institute.png"
                            [alt]="'HomePage.Introduction.DanaFarberAlt'">
                        <img class="logos__square" src="assets/images/logo-minderoo.png"
                            [alt]="'HomePage.Introduction.MinderooAlt'">
                    </div>
                </div>

                <div class="introduction__image margin-left-10">
                    <img class="image" src="assets/images/brain.png" [alt]="'HomePage.Introduction.Brain'">
                </div>

            </div>
        </div>
    </section>

        <div class="row">
            <a #secondView></a>
            <section>
                <p class="Message margin-top-120 margin-left-50 margin-right-80">
                    <b>Thank you to everyone who has participated in the project. We continue to analyze and share the data generated through your partnership, which will help continue to shape the future of research in brain tumors.</b>
                </p>
            </section>
        </div>

        <section
            class="main-timeline-title">
            <div class="row">
                <section
                    class="Message col-lg-6 col-lg-offset-3 col-md-8 col-md-offset-2 col-sm-8 col-sm-offset-2 col-xs-10 col-xs-offset-1 NoPadding">
                    <h1 class="Message-title">
                        Brain Tumor Project Timeline
                    </h1>
                </section>
            </div>

            <div class="container py-5">
                <div class="main-timeline">
                    <div class="timeline left">
                        <div class="card WrapperTL">
                            <div class="card-body p-4 WrapperTL">
                                <ul>
                                    <h1>2019</h1>
                                    <li><h4 class="mb-0">Project launched through collaboration with patients, advocates, and caregivers, open to adults with primary brain tumors. At the time of launch, the project was named “The Brain Cancer Project.”</h4></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div class="timeline right">
                        <div class="card WrapperTL">
                            <div class="card-body p-4 WrapperTL">
                                <ul>
                                    <h1>2020</h1>
                                    <li><h4 class="mb-0">After additional engagement with patients and caregivers, the project is expanded to enroll pediatric patients. The website is redesigned to make it more inclusive to all ages.</h4></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div class="timeline left">
                        <div class="card WrapperTL">
                            <div class="card-body p-4 WrapperTL">
                                <ul>
                                    <h1>2021</h1>
                                    <li><h4 class="mb-0">Continued feedback from the community leads to the project being renamed “The Brain Tumor Project.”</h4></li>
                                    <li><h4 class="mb-0"> Project team engages in Brain Tumor Social Media (#BTSM) monthly Twitter chat about the project.</h4></li>
                                    <li><h4 class="mb-0"><a class="mb-0" target="_blank" href="https://cbtn.org/news/childrens-brain-tumor-network-receives-critical-government-support-for-genetic-research-of-childhood-tumors" style="color:#1862AB;"><u>Partnership with Children’s Brain Tumor Network (CBTN) announced.</u></a></h4></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div class="timeline right">
                        <div class="card WrapperTL">
                            <div class="card-body p-4 WrapperTL">
                                <ul>
                                    <h1>2023</h1>
                                    <li><h4 class="mb-0">Yearly social media campaign during Brain Tumor Awareness Month (May) including participant testimonials and staff highlights.</h4></li>
                                    <li><h4 class="mb-0">Exhibited at the American Brain Tumor Association (ABTA) 50th Anniversary conference, American Association for Cancer Research (AACR) Special Cancer Conference on Brain Cancer, ABTA 5k in NTC, and University of Florida Cancer Chomp 5K.</h4></li>
                                    <li><h4 class="mb-0">Cohort of diffuse midline glioma (DMG) and atypical teratoid rhabdoid tumor (ATRT) samples collected through CBTN are molecularly characterized (sequenced) in order to expand the pediatric brain tumor data available to researchers.</h4></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div class="timeline left">
                        <div class="card WrapperTL">
                            <div class="card-body p-4 WrapperTL">
                                <ul>
                                <h1>2025</h1>
                                <li><h4>Over 315 patients with primary brain tumors have fully enrolled. Data generated through the project will be de-identified and added to repositories for ongoing research.</h4></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <div class="row">
            <section
                class="Message col-lg-6 col-lg-offset-3  ">
                <p class="Message margin-top-20">
                    Questions? Please reach out to us at any time at <a class='Link' href='mailto:info@joincountmein.org'>info@joincountmein.org</a>.
                </p>
            </section>
        </div>

    </div>

</main>
